import { initialImagesStateProps, useImagesContext } from "./context";
import Image from "components/img";
import "./imgCard.scss";

interface CardProps {
  item: initialImagesStateProps;
  index: number;
}

const ImageCard: React.FC<CardProps> = ({ item, index }) => {
  const { onDragOver, onDragStart, onDrop, onDelete, onReplace } =
    useImagesContext();
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files as FileList;
    const file = files?.[0];
    if (!file) return;

    onReplace(index, files);
  };

  return (
    <div
      className={"image-card"}
      draggable
      onDragStart={(e) => {
        e.stopPropagation();
        onDragStart(index);
      }}
      onDrop={() => onDrop(index)}
      onDragOver={onDragOver}
    >
      {/* <img src={item.preview} alt="room" className="image-card-img" />
      < */}
      <Image src={item.preview} alt="room" className="default-image" />

      <div className="image-card-actions">
        <label className="btn-change">
          변경
          <input type="file" hidden onChange={onChange} />
        </label>
        <button
          type="button"
          className="btn-delete"
          onClick={() => {
            onDelete(index);
          }}
        >
          삭제
        </button>
      </div>
    </div>
  );
};

export default ImageCard;
